import { useGetConversationSummaryApi } from "../api/methods/use-get-conversation-summary-api";
import React from "react";

export const useGetSummary = (params: {
  organizationId: string;
  responseId: string;
}) => {
  const [isLoading, setIsLoading] = React.useState(false);

  const getSummary = useGetConversationSummaryApi(
    params.organizationId,
    params.responseId
  );

  const [summary, setSummary] = React.useState("");

  React.useEffect(() => {
    setSummary("");
    setIsLoading(false);
  }, [params.organizationId, params.responseId]);

  const handleGetSummary = async () => {
    setIsLoading(true);
    setSummary("");
    try {
      const summaryText = await getSummary();
      if (summaryText) {
        setSummary(summaryText);
      }
    } catch (error) {
      console.error("Failed to load summary", error);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    summary,
    getSummary: handleGetSummary,
  };
};
